import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SavedSearchBaseComponent } from './saved-search-base.component.js';
import {
	SearchService,
	ViewType,
	CompanyService,
	DeploymentContext,
} from '@Common';

@Component({
	selector: 'saved-search-summary',
	templateUrl: './saved-search-summary.component.html',
	styleUrls: ['./saved-search-summary.component.scss'],
	standalone: false,
})
export class SavedSearchSummaryComponent extends SavedSearchBaseComponent {
	@Input() searchTitle: string;
	@Input() viewType: ViewType;
	// Event emitted when the add item button is clicked. Emits nothing if addItemTemplate is used
	@Output() editSavedSearch = new EventEmitter<void>();

	constructor(
		dc: DeploymentContext,
		searchService: SearchService,
		companyService: CompanyService
	) {
		super(dc, searchService, companyService);
	}

	public get isModalView(): boolean {
		return this.viewType === ViewType.Modal;
	}

	public editQuery(): void {
		this.editSavedSearch.emit();
	}
}
